module.exports = __webpack_public_path__ + "static/media/HalfRectangOutline.a97e64ae.png";